<div class="auction-details-img">
  <!-- Main image display -->
  <div class="tab-content" id="v-pills-tabContent">
    <div class="tab-pane fade show active" id="v-pills-img1" role="tabpanel">
      <div class="auction-details-tab-img">
        <img
          [src]="
            images.activeImage?.thumb || '/assets/images/defualt-image.jpg'
          "
          (click)="
            openActiveImg(
              images.activeImage?.thumb || '/assets/images/defualt-image.jpg'
            )
          "
          alt="Horse image"
          class="cursor-pointer"
          />
          @if (images.activeImage?.type === 'video') {
            <span
              class="position-absolute"
              >
              <img
                src="assets/images/video-player.svg"
                class="play-icon cursor-pointer"
            (click)="
              openActiveImg(
                images.activeImage?.thumb || '/assets/images/defualt-image.jpg'
              )
            "
                />
              </span>
            }
          </div>
        </div>
      </div>
      @if (images.thumbnails.length > 1) {
        <div class="slider-btn-grp">
          <div class="slider-btn category-slider-prev">
            <svg
              width="9"
              height="15"
              viewBox="0 0 9 15"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path d="M0 7.50009L9 0L3.27273 7.50009L9 15L0 7.50009Z" />
            </svg>
          </div>
          <div class="slider-btn category-slider-next">
            <svg
              width="9"
              height="15"
              viewBox="0 0 9 15"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path d="M9 7.50009L0 0L5.72727 7.50009L0 15L9 7.50009Z" />
            </svg>
          </div>
        </div>
      }
      <div
        class="nav nav-pills"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
        >
        <div class="swiper auction-details-nav-slider w-100">
          <div class="swiper-wrapper">
            @for (image of images.thumbnails; track image; let i = $index) {
              <div
                class="swiper-slide"
                >
                <div class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    [class.active]="i === activeImageIndex"
                    (click)="setActiveImage(i)"
                    attr.aria-selected="{{ i === activeImageIndex }}"
                    >
                    @if (image?.type === 'video') {
                      <span (click)="openLightbox(i)">
                        <img src="assets/images/video-player.svg" class="play-icon" />
                      </span>
                    }
                    <img [src]="image?.thumb" alt="Thumbnail" />
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
